import { PropsWithChildren } from 'react'

import { Text } from '@lounge-fe/ui-kit/src/components/Text'

export const Title = ({
  children,
  isTitlePrimary,
}: PropsWithChildren<{ isTitlePrimary?: boolean }>): JSX.Element => (
  <div className="my-6 flex items-center justify-center">
    <Text
      variant="title-five"
      as={isTitlePrimary ? 'h1' : 'h3'}
      className="text-center"
    >
      {children}
    </Text>
  </div>
)
